import React from "react";
import classNames from "classnames";
import { Currency } from "@app/types/currencies";
import { CurrencyToggle } from "./components/currency-toggle/CurrencyToggle";

type Props = {
  label: string;
  value: string;
  currency: Currency;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onCurrencyChange: React.MouseEventHandler;
};

export const CurrencyInput: React.FC<Props> = ({
  label,
  value,
  currency,
  onChange,
  onCurrencyChange,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-regular text-base-400">{label}</label>

      <div className="relative">
        <input
          type="number"
          value={value}
          onChange={onChange}
          onKeyDown={(evt) =>
            ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
          }
          className={classNames(
            "input input-bordered border-divider bg-grey-light h-12 w-full border-1 border-solid py-2.5 pr-36 pl-4 duration-300",
            "text-regular text-base-400 rounded-sm",
            "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
            "focus:border-primary-content focus:outline-none",
          )}
        />

        <CurrencyToggle
          className="absolute top-0 right-0 flex h-full items-center pr-4"
          currency={currency}
          onCurrencyChange={onCurrencyChange}
        />
      </div>
    </div>
  );
};
